export const useDownload = () => {
  const downloadFile = (url: string) => {
    try {
      const link = document.createElement("a")
      link.href = url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error("Download failed:", error)
    }
  }

  return {
    downloadFile
  }
}
